import { useTranslation } from 'react-i18next';

import Typography from '../../../components/Typography';
import { SAFE_EMPTY_STRING } from '../../../db/polls/constants';
import { UnpublishedPollItem } from '../../../db/polls/types';
import { i18nNS } from '../../../i18n';
import { Root } from './styles';
import { format } from '../../../utils/datetime';
import { Stack } from '@mui/material';
import CalendarIcon from '../../../icons/CalendarIcon';

export interface PollWidgetProps {
  classStartTime: UnixTime;
  poll: UnpublishedPollItem;
  className?: string;
}

const PollWidget = ({ classStartTime, poll, className }: PollWidgetProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { slug, title } = poll;

  const showPlaceholderText = !slug || slug === SAFE_EMPTY_STRING;

  return (
    <Root className={className}>
      <Stack direction="row" alignItems="center" p={1.25} gap={1}>
        <CalendarIcon variant="filled" size={16} color="grey.600" />
        <Typography variant="paragraphBold" color="grey.600" noWrap>
          {format(classStartTime, "do MMM, yyyy 'on' hh:mm a")}
        </Typography>
      </Stack>
      <Typography variant="paragraphBold" component="h6" textTransform="uppercase" px={1.25} py={0.5} noWrap>
        {title || t('untitled_poll', { ns: i18nNS.POLL })}
      </Typography>
      <Typography
        variant="paragraphRegular"
        noWrap
        p={1.25}
        color={showPlaceholderText ? 'grey.500' : 'inherit'}
      >
        {showPlaceholderText ? t('question_not_set', { ns: i18nNS.POLL }) : slug}
      </Typography>
    </Root>
  );
};

export default PollWidget;
